import { createContext, ReactNode } from "react";

type HeaderContextType = {
  setHeaderContent: (content: ReactNode) => void;
  headerContent: ReactNode;
};

export const HeaderContext = createContext<HeaderContextType | undefined>(
  undefined
);
